import { render, staticRenderFns } from "./GuestOrderDetailsDialog.vue?vue&type=template&id=47c89e1d&scoped=true"
import script from "./GuestOrderDetailsDialog.vue?vue&type=script&lang=js"
export * from "./GuestOrderDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./GuestOrderDetailsDialog.vue?vue&type=style&index=0&id=47c89e1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c89e1d",
  null
  
)

export default component.exports